<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" @submit.native.prevent>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getRealNamePayListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option v-for="item in orderState" :key="item.description" :label="item.description" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="getRealNamePayListHandle">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		   border
		   fit
		   highlight-current-row
		   style="width: 100%;"
		   :header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column prop="id" label="订单号" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column label="ICCID号" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column label="金额(元)" align="center">
                <template slot-scope="scope">{{ scope.row.price/100 }}</template>
            </el-table-column>
            <el-table-column label="支付状态" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.pay_state == 0">待支付</span>
                    <span v-if="scope.row.pay_state == 1">已支付</span>
                    <span v-if="scope.row.pay_state == 2">未支付</span>
                    <span v-if="scope.row.pay_state == 3">已退款</span>
                    <span v-if="scope.row.pay_state == 4">退款中</span>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" align="center"  label="下单时间" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button @click="resetValidation(scope.row)" type="text" size="small" plain icon="el-icon-search">重置验证次数</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>   
    </div>
</template>

<script>
import { getOrderStateList, getRealNamePayList } from '@/api/order.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                payState: ''
            },
            orderState: [], //订单状态列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },
    methods: {
        //查询
        getRealNamePayListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');//重置翻页组件的当前页为第1页
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);//组合搜索参数与分页参数及格式化时间

            getRealNamePayList(data).then(res => {//发送请求
                common.listCallback(this, res, 'tbpg');//赋值
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getRealNamePayListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getRealNamePayListHandle();
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        resetValidation(row){
            common.sysRequest('bindPhone/update/state', { iccid: row.iccid }, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: res.data.message,
                        type: 'success'
                    });
                    // this.$router.replace('')
                }else {
                    this.$message.error(res.data.message);
                }
            })
        }
    },
    created(){
        //获取订单状态列表
        getOrderStateList().then(res => {
            if(res.data.code == 200){
                this.orderState = res.data.data;
            }
        })
    }
}
</script>

<style>

</style>